// extracted by mini-css-extract-plugin
export default {"root":"_2Owa3","content":"_1_7N7","head":"_3sSbE"};